import React from "react";
import { BinanceIcon, Star } from "../icon/IconTheme";
const ItemCard = ({
	img,
	title,
	price,
	bidder,
	rating,
	index,
	setIndex,
	setModalOpen,
	serial,
}) => {
	const handleModal = () => {
		setIndex(serial);
		setModalOpen(true);
	};
	return (
		<>
			<div className="col-6 col-md-4 col-xl-3">
				<div className="item-card" onClick={handleModal}>
					<div className="item-card-img">
						<img src={img} alt="" />
					</div>
					<div className="item-card-content">
						{title && <h4 className="subtitle">{title}</h4>}
						<div className="d-flex flex-wrap justify-content-between">
							{bidder && (
								<div>
									<div className="subtext">Current Bid</div>
									<BinanceIcon /> {bidder}
								</div>
							)}
							<div className="price text-end">
								<div className="subtext">Price</div>
								<BinanceIcon /> {price}
							</div>
						</div>
						<div className="mt-3 rating">
							{rating === "0" && (
								<>
									<Star />
									<Star />
									<Star />
									<Star />
								</>
							)}
							{rating !== "0" && (
								<>
									<span className="me-1">({rating})</span>
									<Star />
								</>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ItemCard;
